import React from "react";
import { useQuery } from "react-query";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ButtonWithIcon, Container } from "../../lib";
import { getFanReportLogPerUserAll } from "../../../../api/report/reportApi";
import BackBtn from "../../lib/BackBtn";
import FanReportLogTableUsers from "./FanReportLogTableUsers";

interface LogData {
  userLogs: Array<{
    _id: string;
    userId: string;
    nationalCode: string;
    description: string;
    created_at?: string;
    status?: string;
  }>;
  totalRows: number;
  totalPages: number;
  userInfo?: {
    id: number;
    f_name: string;
    l_name: string;
    mobile: string;
    national_code: string;
    activation: number | null;
    birthDate?: string;
    city?: {
      id: number;
      name: string;
      slug: string;
    };
    male?: boolean;
    verified_gender?: boolean;
  };
  verificationInfo?: {
    _id: string;
    nationalCode: string;
    phone: string[];
    birthDate: number;
    createdAt: string;
    fatherName: string;
    firstName: string;
    genderType: string;
    lastName: string;
    male : boolean;
    officeCode: string;
    officeName: string;
    serial: string;
    shenasnameNo: string;
    shenasnameSeri: string;
    verifiedBySabteAhval?: string;
    verifiedByShakar?: string;
    __v: number;
  };
}

interface QueryStringType {
  page: number | string;
  search: string;
  numberInPage: number | string;
}

const FanReportLogListUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state =
    (location.state as {
      userId?: number;
    }) || {};

  React.useEffect(() => {
    if (!state.userId) {
      navigate(-1);
    }
  }, [navigate, state.userId]);

  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize queryString with default values
  const [queryString, setQueryString] = React.useState<QueryStringType>({
    page: 1,
    search: searchParams.get("search") || "",
    numberInPage: 10,
  });

  const { data, isLoading, isError, refetch } = useQuery<LogData>(
    ["fanReportLogUsers", queryString.page, state.userId, queryString.search],
    () => {
      if (!state.userId) return { userLogs: [], totalRows: 0, totalPages: 0 };
      return getFanReportLogPerUserAll(state.userId, {
        page: queryString.page,
        numberInPage: queryString.numberInPage,
        search: queryString.search,
      });
    },
    {
      enabled: !!state.userId,
      refetchOnWindowFocus: false,
    }
  );

  const setQSandEnable = (values: QueryStringType) => {
    setQueryString(values);
    refetch();
  };

  // This function is called when pagination is clicked
  const setQS = (page: number) => {
    // Update state without changing URL
    setQueryString((prev) => {
      return {
        ...prev,
        page: page,
      };
    });

    // Force a refetch with the new page
    setTimeout(() => {
      refetch();
    }, 0);
  };

  if (isLoading) return <div>در حال بارگذاری...</div>;
  if (isError) return <div>خطا در دریافت اطلاعات</div>;
  if (!data) return <div>داده‌ای یافت نشد</div>;


  return (
    <Container className="bg-white p-0 mt-10">
      <div className="d-flex align-items-center justify-content-between table-header">
        <div className="d-flex align-items-center gap-4">
          <h3>گزارش فعالیت‌های کاربر</h3>
        </div>
        <BackBtn onClick={() => navigate(-1)} />
      </div>

      {/* <div className={"d-flex align-items-center justify-content-between table-header"}>
        <div className={"d-flex align-items-center gap-4"}>          
          <SearchForm
            onSubmitCallback={(searchTerm: string) => {
              setQSandEnable({ ...queryString, search: searchTerm, page: 1 });
              
              // Update search parameter in URL but keep page parameter unchanged
              const newParams = new URLSearchParams(searchParams);
              newParams.set("search", searchTerm);
              setSearchParams(newParams);
            }}
            searchTerm={queryString.search}
          />
        </div>
      </div> */}
      {data?.userInfo && (
        <div className="card my-4 border mx-2 ">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <h5 className="card-title">اطلاعات کاربر</h5>
                <p className="mb-1">
                  <strong>نام:</strong> {data.userInfo?.f_name || ""}{" "}
                  {data.userInfo?.l_name || ""}
                </p>
                <p className="mb-1">
                  <strong>کد ملی:</strong> {data.userInfo?.national_code || ""}
                </p>
                <p className="mb-1">
                  <strong>موبایل:</strong> {data.userInfo?.mobile || ""}
                </p>
              </div>
              <div className="col-md-6">
                <h5 className="card-title">وضعیت فعال‌سازی</h5>

                <ActivationStatusBox activation={data.userInfo?.activation} />
              </div>
              <div className="col-md-6">
                <p className="mb-1">
                  <strong>جنسیت:</strong>
                  {data.userInfo?.male === null || data.userInfo?.male === undefined 
                    ? "نامشخص" 
                    : data.userInfo.male ? "مرد" : "زن"}
                </p>
              </div>
            </div>

            {data?.verificationInfo && (
              <div className="mt-4 ">
                <h6 className="card-title mb-3">اطلاعات تایید شده ثبت احوال</h6>
                <div className="row py-4 border  ">
                  <div className="col-md-6 ">
                    <p className="mb-1">
                      <strong>نام:</strong> {data.verificationInfo.firstName}
                    </p>
                    <p className="mb-1">
                      <strong>نام خانوادگی:</strong>{" "}
                      {data.verificationInfo.lastName}
                    </p>
                    <p className="mb-1">
                      <strong>جنسیت:</strong>{" "}
                      {data.verificationInfo.male ? "مرد" : "زن"}
                    </p>
                    <p className="mb-1">
                      <strong>نام پدر:</strong>{" "}
                      {data.verificationInfo.fatherName}
                    </p>
                    <p className="mb-1">
                      <strong>کد ملی:</strong>{" "}
                      {data.verificationInfo.nationalCode}
                    </p>
                    <p className="mb-1">
                      <strong>شماره سریال:</strong>{" "}
                      {data.verificationInfo.serial}
                    </p>
                    <p className="mb-1">
                      <strong>تاریخ تولد:</strong>{" "}
                      {new Date(
                        data.verificationInfo.birthDate
                      ).toLocaleDateString("fa-IR")}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1">
                      <strong>سری شناسنامه:</strong>{" "}
                      {data.verificationInfo.shenasnameSeri}
                    </p>
                    <p className="mb-1">
                      <strong>شماره شناسنامه:</strong>{" "}
                      {data.verificationInfo.shenasnameNo}
                    </p>
                    <p className="mb-1">
                      <strong>تاریخ ایجاد:</strong>{" "}
                      {new Date(
                        data.verificationInfo.createdAt
                      ).toLocaleDateString("fa-IR")}
                    </p>
                    {data.verificationInfo.verifiedBySabteAhval && (
                      <p className="mb-1">
                        <strong>تایید شده توسط ثبت احوال:</strong>{" "}
                        {new Date(
                          data.verificationInfo.verifiedBySabteAhval
                        ).toLocaleDateString("fa-IR")}
                      </p>
                    )}
                    {data.verificationInfo.verifiedByShakar && (
                      <p className="mb-1">
                        <strong>تایید شده توسط سرویس:</strong>{" "}
                        {new Date(
                          data.verificationInfo.verifiedByShakar
                        ).toLocaleDateString("fa-IR")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {data?.userLogs && data.userLogs.length > 0 && state.userId ? (
        <FanReportLogTableUsers
          data={data}
          queryString={queryString}
          userId={state.userId}
          setQueryString={setQS}
          refetch={refetch}
          numberInPage={Number(queryString.numberInPage)}
        />
      ) : (
        <p className={"p-2 m-2"}>اطلاعاتی یافت نشد</p>
      )}
    </Container>
  );
};

interface SearchFormProps {
  onSubmitCallback: (searchTerm: string) => void;
  searchTerm: string;
}

const SearchForm = ({ onSubmitCallback, searchTerm }: SearchFormProps) => {
  return (
    <Formik
      initialValues={{ searchTerm: searchTerm || "" }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);
        if (onSubmitCallback) {
          onSubmitCallback(values.searchTerm);
        }
      }}
    >
      {({ isSubmitting, handleChange, values }) => (
        <Form
          className={"d-flex align-items-center gap-3"}
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <Field
            type="text"
            name="searchTerm"
            className="border rounded p-2 bg-white w-c-130 text-right"
            placeholder="جستجو"
            onChange={handleChange}
            value={values.searchTerm}
          />
          <ErrorMessage
            name="searchTerm"
            component="div"
            className="text-red-600"
          />
          <ButtonWithIcon
            btnText="جستجو"
            iconName="magnifier"
            type="submit"
            disabled={isSubmitting}
          />
        </Form>
      )}
    </Formik>
  );
};

interface ActivationStatusBoxProps {
  activation: number | null;
}

const ActivationStatusBox: React.FC<ActivationStatusBoxProps> = ({
  activation,
}) => {
  const getActivationInfo = (activation: number | null) => {
    switch (activation) {
      case null:
        return {
          text: "کاربر نامشخص",
          color: "warning",
          bgColor: "#fff3cd",
          borderColor: "#ffeaa7",
        };
      case 1:
        return {
          text: "تایید شده با OTP",
          color: "info",
          bgColor: "#d1ecf1",
          borderColor: "#bee5eb",
        };
      case 2:
        return {
          text: "تایید نشده (UID و Jibit ناموفق)",
          color: "danger",
          bgColor: "#f8d7da",
          borderColor: "#f5c6cb",
        };
      case 3:
        return {
          text: "تایید شده",
          color: "success",
          bgColor: "#d4edda",
          borderColor: "#c3e6cb",
        };
      case 4:
        return {
          text: "رد شده (توسط UID یا Jibit)",
          color: "danger",
          bgColor: "#f8d7da",
          borderColor: "#f5c6cb",
        };
      default:
        return null;
    }
  };

  const activationInfo = getActivationInfo(activation);

  if (!activationInfo) {
    return null;
  }

  return (
    <div
      className="p-3 rounded border"
      style={{
        backgroundColor: activationInfo.bgColor,
        borderColor: activationInfo.borderColor,
        borderWidth: "2px",
      }}
    >
      <div className="d-flex align-items-center">
        <div
          className="rounded-circle me-3"
          style={{
            width: "12px",
            height: "12px",
            backgroundColor:
              activationInfo.color === "success"
                ? "#28a745"
                : activationInfo.color === "danger"
                ? "#dc3545"
                : activationInfo.color === "warning"
                ? "#ffc107"
                : activationInfo.color === "info"
                ? "#17a2b8"
                : "#6c757d",
          }}
        ></div>
        <span className="fw-bold" style={{ color: "#495057" }}>
          {activationInfo.text}
        </span>
      </div>
    </div>
  );
};

export default FanReportLogListUsers;
